import { Accordion, AccordionProps } from '@lfg/ui/components';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import React from 'react';

interface SectionAccordionProps extends AccordionProps {
  bodyContent: React.ReactNode;
}

export function SectionAccordion({ bodyContent, ...rest }: SectionAccordionProps) {
  return (
    <Accordion
      wrapperSx={{
        backgroundColor: 'transparent',
        boxShadow: 'none',
        '&.MuiAccordion-root': {
          overflow: 'visible',
        },
      }}
      titleWrapperProps={{
        sx: {
          padding: 0,
        },
      }}
      defaultExpanded
      icon={<KeyboardArrowDownIcon sx={{ color: 'white' }} />}
      titlePadding={'0'}
      titleProps={{
        sx: {
          backgroundColor: 'transparent',
          color: 'white',
          fontWeight: 500,
        },
      }}
      contentWrapperProps={{
        sx: {
          padding: 0,
          borderRadius: '4px',
        },
      }}
      renderContent={() => bodyContent}
      {...rest}
    />
  );
}
